import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { ThunkDispatch } from 'redux-thunk';
import { RootState } from '../../store';
// import axios from 'axios';
import Loading from '../../UI/Loading';
import bemClassName from '../../utils/bem';
import Service from '../../API/Service';
import getQueryParam from '../../utils/queryParams';
import { checkAuthStatus } from '../../store/reducers/profile/autorizationStatutsSlice';

const auth = bemClassName('auth');

const Autoreg = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const isLogin = useSelector((state: RootState) => state.autorizationStatus.isLogin);
  const [tokenError, setTokenError] = useState<string>();

  const getToken = (key: string) => {
    if (!isLogin) {
      Service.getTokens(key)
        .then((result) => {
          const expiresTime = Date.now();
          const expiresInSeconds = Number(result.expires_in);
          const tokenExpirationTime = expiresTime + +expiresInSeconds * 1000;
          localStorage.setItem('refresh_token', String(result.refresh_token));
          localStorage.setItem('tokenExpirationTime', String(tokenExpirationTime));
          localStorage.setItem('tokenLifetime', String(expiresInSeconds));
          localStorage.setItem('access_token', String(result.access_token));
          dispatch(checkAuthStatus());
          const passport = getQueryParam('passport');
          if (passport) {
            navigate('/account#proof-of-identity');
          } else {
            navigate('/account#current-bookings');
          }
        })
        .catch((error) => {
          const errorText = error instanceof Error ? error.message : String(error);
          setTokenError(errorText);
        });
    }
  };

  useEffect(() => {
    if (!isLogin) {
      const key = getQueryParam('key');
      if (key) {
        getToken(key);
      } else {
        setTokenError('Не передан ключ авторизации');
      }
    } else {
      setTokenError('Доступ запрещен');
    }
  }, []);

  return !tokenError ? (
    <Loading externalClassName={auth()} />
  ) : (
    <>
      <h1>{tokenError}</h1>
    </>
  );
};

export default Autoreg;
